import { get } from 'svelte/store';
import * as echarts from 'echarts';
import { _ } from 'svelte-i18n';

import { quickCategoriesConfig } from '../../../Planning/QuickCategories/QuickCategoriesConfig';
import { smartRounding } from '../../../telematics/tools/smartRounding';
import { availableProcessStages } from '../../../../../stores/Const';

export class ChartDailyPeopleDataConverter {
    private static categoriesMap = {
        monday: 'monday',
        tuesday: 'tuesday',
        wednesday: 'wednesday',
        thursday: 'thursday',
        friday: 'friday',
        saturday: 'saturday',
        sunday: 'sunday',
    };

    public static convertAPIFormatToChartData<DT>(
        data: DT,
        defaultOption: echarts.EChartsOption,
        colors: { primary: string; secondary: string }
    ): echarts.EChartsOption {
        let chartData: echarts.EChartsOption = {};
        chartData = JSON.parse(JSON.stringify(defaultOption));
        // left labels
        try {
            chartData.yAxis[0].data = Object.keys(data)
                .filter(k => typeof this.categoriesMap[k] !== 'undefined')
                .map(k => {
                    return {
                        value: get(_)(this.categoriesMap[k]),
                        textStyle: {
                            fontWeight: 'normal', // e.class.includes('bold') ? 'bold' : 'normal',
                            // textShadowColor: '#000000',
                            // textShadowBlur: 1,
                        },
                    };
                });
        } catch (e) {
            console.error('ChartDailyPeopleDataConverter.convertAPIFormatToChartData() yAxis 0', e);
        }
        // console.log('chartData.yAxis[0].data', chartData.yAxis[0].data);
        // inside labels (values)
        try {
            chartData.yAxis[1].data = Object.keys(data)
                .filter(k => typeof this.categoriesMap[k] !== 'undefined')
                .map(k => {
                    let rounded = new smartRounding().getRoundedValues(data[k], '', {
                        convert_nicer: true,
                    });
                    return {
                        value: [
                            rounded.rounded_value,
                            rounded.rounded_title,
                            rounded.rounded_unit,
                        ].join(' '),
                        textStyle: {
                            fontWeight: 'bold', // e.class.includes('bold') ? 'bold' : 'normal'
                            color: this.getColor(this.categoriesMap[k] ?? ''),
                            textShadowColor: this.getBackgroundColor(this.categoriesMap[k] ?? ''),
                            textShadowBlur: 1,
                        },
                    };
                });
        } catch (e) {
            console.error('ChartDailyPeopleDataConverter.convertAPIFormatToChartData() yAxis 1', e);
        }
        // // values
        try {
            chartData.series[0].data = Object.keys(data)
                .filter(k => typeof this.categoriesMap[k] !== 'undefined')
                .map(k => {
                    return {
                        value: data[k] ?? 0,
                        itemStyle: {
                            color: this.getBackgroundColor(this.categoriesMap[k] ?? ''),
                        },
                    };
                });
            // console.debug('ChartPopulationDataConverter.getChartDataFromAPI()', chartData);
        } catch (e) {
            console.error('ChartDailyPeopleDataConverter.convertAPIFormatToChartData() series', e);
        }
        return chartData;
    }

    private static getColor(categoryId: string): string {
        return quickCategoriesConfig?.find(e => e.id === categoryId)?.color ?? '#FFFFFF';
    }

    private static getBackgroundColor(categoryId: string): string {
        return quickCategoriesConfig?.find(e => e.id === categoryId)?.backgroundColor ?? '#000000';
    }
}
